// @flow
import { put, takeEvery, call, select } from 'redux-saga/effects';

import translate from '../../translate';
import api from '@api';
import {
    activateEmailTemplateVersionDetailFailure,
    activateEmailTemplateVersionDetailSuccess,
    createEmailTemplateDetailFailure,
    createEmailTemplateDetailSuccess,
    createEmailTemplateVersionDetailFailure,
    createEmailTemplateVersionDetailSuccess, deleteEmailTemplateDetailFailure, deleteEmailTemplateDetailSuccess,
    deleteEmailTemplateVersionDetailFailure,
    deleteEmailTemplateVersionDetailSuccess,
    editEmailTemplateDetailFailure,
    editEmailTemplateDetailSuccess,
    editEmailTemplateVersionDetailFailure,
    editEmailTemplateVersionDetailSuccess,
    getEmailTemplateDetailFailure, getEmailTemplateDetailFetch,
    getEmailTemplateDetailSuccess, testEmailTemplateVersionDetail,
    testEmailTemplateVersionDetailFailure, testEmailTemplateVersionDetailSuccess
} from './reducer';
import { getEmailTemplatesListFetch } from '../emailTemplates/reducer';

const getEmailTemplateDetailRequest = async (id: any) => {
    const res = await api('get', `api/secure/email-templates/${id}`);
    return res.data;
};

export function* getEmailTemplateDetail(action: any): any {
    try {
        const response = yield call((): any => getEmailTemplateDetailRequest(action.payload));
        yield put(getEmailTemplateDetailSuccess(response.data));
    } catch (error) {
        yield put(getEmailTemplateDetailFailure(error));
    }
}

export function* watchGetEmailTemplateDetail(): any {
    yield takeEvery('emailTemplateDetail/getEmailTemplateDetailFetch', getEmailTemplateDetail);
}

const createEmailTemplateRequest = async (data: string) => {
    const res = await api('post', `api/secure/email-templates`, data);
    return res.data;
};

export function* createEmailTemplate(action: any): any {
    try {
        const response = yield call((): any => createEmailTemplateRequest(action.payload));

        yield put(getEmailTemplatesListFetch());
        yield put(
            createEmailTemplateDetailSuccess({
                ...response.data,
                messageSuccess: {
                    title: translate('emailTemplateDetail.message.emailTemplateCreated'),
                },
            })
        );
        yield put(getEmailTemplateDetailFetch(response.data.ID));
    } catch (error) {
        yield put(createEmailTemplateDetailFailure(error));
    }
}

export function* watchCreateEmailTemplate(): any {
    yield takeEvery('emailTemplateDetail/createEmailTemplateDetail', createEmailTemplate);
}

const editEmailTemplateRequest = async (data: any) => {
    const res = await api('put', `api/secure/email-templates/${data.idEmailTemplate}`, data.data);
    return res.data;
};

export function* editEmailTemplate(action: any): any {
    try {
        const response = yield call((): any => editEmailTemplateRequest(action.payload));

        yield put(getEmailTemplatesListFetch());
        yield put(
            editEmailTemplateDetailSuccess({
                ...response.data,
                messageSuccess: {
                    title: translate('emailTemplateDetail.message.emailTemplateUpdate'),
                },
            })
        );
        yield put(getEmailTemplateDetailFetch(action.payload.idEmailTemplate));
    } catch (error) {
        yield put(editEmailTemplateDetailFailure(error));
    }
}

export function* watchEditEmailTemplate(): any {
    yield takeEvery('emailTemplateDetail/editEmailTemplateDetail', editEmailTemplate);
}

const deleteEmailTemplateRequest = async (data: any) => {
    const res = await api('delete', `api/secure/email-templates/${data.idEmailTemplate}`);
    return res.data;
};

export function* deleteEmailTemplate(action: any): any {
    try {
        const response = yield call((): any => deleteEmailTemplateRequest(action.payload));

        yield put(getEmailTemplatesListFetch());
        yield put(
            deleteEmailTemplateDetailSuccess({
                ...response.data,
                messageSuccess: {
                    title: translate('emailTemplateDetail.message.emailTemplateDeleted'),
                },
            })
        );
        yield put(getEmailTemplateDetailFetch(action.payload.idEmailTemplate));
    } catch (error) {
        yield put(deleteEmailTemplateDetailFailure(error));
    }
}

export function* watchDeleteEmailTemplate(): any {
    yield takeEvery('emailTemplateDetail/deleteEmailTemplateDetail', deleteEmailTemplate);
}

const createEmailTemplateVersionRequest = async (data: any) => {
    const res = await api('post', `api/secure/email-templates/${data.idEmailTemplate}/version`, data.data);
    return res.data;
};

export function* createEmailTemplateVersion(action: any): any {
    try {
        const response = yield call((): any => createEmailTemplateVersionRequest(action.payload));

        yield put(getEmailTemplatesListFetch());
        yield put(
            createEmailTemplateVersionDetailSuccess({
                ...response,
                messageSuccess: {
                    title: translate('emailTemplateDetail.message.emailTemplateVersionCreated'),
                },
            })
        );
        yield put(getEmailTemplateDetailFetch(action.payload.idEmailTemplate));
    } catch (error) {
        yield put(createEmailTemplateVersionDetailFailure(error));
    }
}

export function* watchCreateEmailTemplateVersion(): any {
    yield takeEvery('emailTemplateDetail/createEmailTemplateVersionDetail', createEmailTemplateVersion);
}

const editEmailTemplateVersionRequest = async (data: any) => {
    const res = await api(
        'put',
        `api/secure/email-templates/${data.idEmailTemplate}/version/${data.idVersion}`,
        data.data
    );
    return res.data;
};

export function* editEmailTemplateVersion(action: any): any {
    try {
        const response = yield call((): any => editEmailTemplateVersionRequest(action.payload));

        yield put(getEmailTemplatesListFetch());
        yield put(
            editEmailTemplateVersionDetailSuccess({
                ...response,
                messageSuccess: {
                    title: translate('emailTemplateDetail.message.emailTemplateVersionUpdate'),
                },
            })
        );
        yield put(getEmailTemplateDetailFetch(action.payload.idEmailTemplate));
    } catch (error) {
        yield put(editEmailTemplateVersionDetailFailure(error));
    }
}

export function* watchEditEmailTemplateVersion(): any {
    yield takeEvery('emailTemplateDetail/editEmailTemplateVersionDetail', editEmailTemplateVersion);
}

const deleteEmailTemplateVersionRequest = async (data: any) => {
    const res = await api('delete', `api/secure/email-templates/${data.idEmailTemplate}/version/${data.idVersion}`);
    return res.data;
};

export function* deleteEmailTemplateVersion(action: any): any {
    try {
        const response = yield call((): any => deleteEmailTemplateVersionRequest(action.payload));

        yield put(
            deleteEmailTemplateVersionDetailSuccess({
                ...response,
                messageSuccess: {
                    title: translate('emailTemplateDetail.message.emailTemplateVersionDeleted'),
                },
            })
        );
        yield put(getEmailTemplateDetailFetch(action.payload.idEmailTemplate));
    } catch (error) {
        yield put(deleteEmailTemplateVersionDetailFailure(error));
    }
}

export function* watchDeleteEmailTemplateVersion(): any {
    yield takeEvery('emailTemplateDetail/deleteEmailTemplateVersionDetail', deleteEmailTemplateVersion);
}

const activateEmailTemplateVersionRequest = async (data: any) => {
    const res = await api(
        'put',
        `api/secure/email-templates/${data.idEmailTemplate}/version/${data.idVersion}/activate`
    );
    return res.data;
};

export function* activateEmailTemplateVersion(action: any): any {
    try {
        const response = yield call((): any => activateEmailTemplateVersionRequest(action.payload));

        yield put(
            activateEmailTemplateVersionDetailSuccess({
                ...response,
                messageSuccess: {
                    title: translate('emailTemplateDetail.message.emailTemplateVersionActivated'),
                },
            })
        );
        yield put(getEmailTemplateDetailFetch(action.payload.idEmailTemplate));
    } catch (error) {
        yield put(activateEmailTemplateVersionDetailFailure(error));
    }
}

export function* watchActivateEmailTemplateVersion(): any {
    yield takeEvery('emailTemplateDetail/activateEmailTemplateDetail', activateEmailTemplateVersion);
}

const testEmailTemplateVersionRequest = async (data: any) => {
    const res = await api(
        'post',
        `api/secure/email-templates/${data.idEmailTemplate}/version/${data.idVersion}/test`,
        data.data
    );
    return res.data;
};

export function* testEmailTemplateVersion(action: any): any {
    try {
        const response = yield call((): any => testEmailTemplateVersionRequest(action.payload));

        yield put(
            testEmailTemplateVersionDetailSuccess({
                ...response,
                messageSuccess: {
                    title: translate('emailTemplateDetail.message.emailTemplateSendTestEmail'),
                },
            })
        );
    } catch (error) {
        yield put(testEmailTemplateVersionDetailFailure(error));
    }
}

export function* watchTestEmailTemplate(): any {
    yield takeEvery('emailTemplateDetail/testEmailTemplateVersionDetail', testEmailTemplateVersion);
}
